import { Pipe, PipeTransform } from '@angular/core';
import { ApiFileService } from '../services/api-file.service';

/** `[src]="projectId | projectImage: imageVersion | async"` — resolves to null when there is no image. */
@Pipe({
  name: 'projectImage',
  standalone: true,
})
export class ProjectImagePipe implements PipeTransform {
  constructor(private apiFileService: ApiFileService) {}

  transform(projectId: number, version: string | null): Promise<string | null> {
    return this.apiFileService.projectImageUrl(projectId, version);
  }
}
